import { render, staticRenderFns } from "./Legand.vue?vue&type=template&id=d3594920&scoped=true&"
import script from "./Legand.vue?vue&type=script&lang=js&"
export * from "./Legand.vue?vue&type=script&lang=js&"
import style0 from "./Legand.vue?vue&type=style&index=0&id=d3594920&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3594920",
  null
  
)

export default component.exports